import { render, staticRenderFns } from "./ClientListAdmin.vue?vue&type=template&id=8397d69a&scoped=true&"
import script from "./ClientListAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8397d69a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
